import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils/cn';
import { statusLabel } from '../types';

interface CampaignStatusBadgeProps {
  status: number | string | undefined | null;
}

/**
 * Buckets the legacy status labels into 5 visual tones. Anything not in the
 * known set falls back to "neutral".
 */
const TONE_BY_LABEL: Record<string, 'neutral' | 'running' | 'success' | 'warn' | 'error'> = {
  Ready: 'neutral',
  Processing: 'warn',
  Running: 'running',
  Complete: 'success',
  'System Complete': 'success',
  'Low Balance': 'warn',
  Error: 'error',
  Cancelling: 'warn',
  Cancelled: 'error',
  'System Cancelled': 'error',
  Pausing: 'warn',
  Paused: 'warn',
  Resuming: 'warn',
  Timeout_Pausing: 'warn',
  Timeout_Paused: 'warn',
};

const TONE_CLASSES: Record<string, string> = {
  neutral: 'border-muted-foreground/20 bg-muted text-muted-foreground',
  running: 'border-sky-200 bg-sky-50 text-sky-900',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-900',
  warn: 'border-amber-200 bg-amber-50 text-amber-900',
  error: 'border-destructive/30 bg-destructive/10 text-destructive',
};

export function CampaignStatusBadge({ status }: CampaignStatusBadgeProps) {
  const label = statusLabel(status);
  if (!label) return <span className="text-xs text-muted-foreground">—</span>;
  const tone = TONE_BY_LABEL[label] ?? 'neutral';
  return (
    <Badge variant="outline" className={cn('font-normal', TONE_CLASSES[tone])}>
      {label}
    </Badge>
  );
}
